import { get, post, postJson, put,imagePost } from './axios'

// 短信发送api

const RESOURCE_BASE_PATH = '/sms'

// const RESOURCE_BASE_PATH = 'http://116.196.113.156/jd-yusms/sms'

// 短信预提交
export const preCommit = p => postJson(`${RESOURCE_BASE_PATH}/pre/commit`, p);
// 新平台的短信发送
export const NewPreCommit = p => postJson(`${RESOURCE_BASE_PATH}/send/test/official`, p);

// 平台的短信发送
export const platformSend = p => postJson(`${RESOURCE_BASE_PATH}/send`, p);

// 精准营销提交发送
export const precisionMarketing = p => postJson(`${RESOURCE_BASE_PATH}/precision-marketing`, p);

// 查询短信批次记录
export const sendBatchPage = p => get(`${RESOURCE_BASE_PATH}/send-batch/page`, p);

// 取消发送
export const sendCancel = p => postJson(`${RESOURCE_BASE_PATH}/cancel`, p);

// 获取导入发送二次发送内容
export const againSend = p => get(`${RESOURCE_BASE_PATH}/again/send/import/${p}`);

// 获取当前系统配置的发送时段
export const getSendTime = p => get(`${RESOURCE_BASE_PATH}/official/send-time`, p);

// 官方打包发送短信效果分析详情/jd-yusms/
export const getOfficialEffect = p => get(`${RESOURCE_BASE_PATH}/official/effect`, p);

// 取消发送
export const crowdCount = p => postJson(`/precisionMarketing/crowdCount/batch`, p);

// 上传富信相关文件通用接口
export const mediaFileUpload = (type,p) => imagePost(`${RESOURCE_BASE_PATH}/upload/media-file/${type}`, p);

// 获取富信富媒体信息通用接口
export const mediaDetail = p => get(`${RESOURCE_BASE_PATH}/media/files/${p}`);

// 获取测试手机号
export const getValidSmsTestMobiles = p => get(`/precisionJdSuffix/getValidSmsTestMobiles`);

// 敏感词检测
export const checkWord = p => postJson(`${RESOURCE_BASE_PATH}/checkJdSensitiveWord`, p);

// 富信测试
export const testMedia = p => postJson(`/sms/send/media-test`, p);

// 获取富信列表
export const getMediaList = p => get(`/sms-media-template/list`,p);

// 获取卡片短信列表
export const getCardList = p => get(`/sms-card-template/list`,p);